import { useState, useRef, useEffect } from "react";

const Card = ({ 
    title, 
    info, 
    infoType = "default", 
    children, 
    item, 
    width = 3, 
    height = 3,
    actions = []
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setShowDropdown((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current && 
                !dropdownRef.current.contains(event.target)
            ) {
                setShowDropdown(false);
            }
        };

        if (showDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDropdown]);

    return (
        <div 
            className={`item-${item} grid-item grid-item--width-${width} grid-item--height-${height}`}
        >
            <div className="dashboard__card">
                <div className="dashboard__card-header">
                    <div className="dashboard__card-title">{title}</div>
                    <div className="dashboard__card-actions" ref={dropdownRef}>
                        <button className="btn-dash-more" onClick={toggleDropdown}>
                            <i className="fa-regular fa-ellipsis-vertical"></i>
                        </button>

                        {showDropdown && actions.length > 0 && (
                            <ul className="dashboard__card-dropdown">
                                {actions.map((action, index) => (
                                    <li 
                                        key={index} 
                                        className="dashboard__card-dropdown-item" 
                                        onClick={() => {
                                            action.onClick && action.onClick();
                                            setShowDropdown(false);
                                        }}
                                    >
                                        {action.icon && <i className={action.icon}></i>}
                                        <span>{action.label}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    {info && (
                        <div className={`dashboard__card-info dashboard__card-info--${infoType}`}>
                            {info}
                        </div>
                    )}
                </div>
                <div className="dashboard__card-body">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Card;
